<template>
    <v-card elevation="0">
        <v-card-text>
            <v-row class="ma-n1">
                <template v-for="item in items">
                    <v-col class="pa-1" :cols="detect == 'mobile' ? 4 : 3" v-bind="item.props_col" :key="item.text">
                        <v-responsive
                            v-bind="{
                                aspectRatio: detect == 'mobile' ? 1 : undefined,
                            }"
                        >
                            <v-btn
                                icon
                                block
                                color="primary"
                                v-bind="{
                                    height: detect == 'mobile' ? '100%' : undefined,
                                }"
                                class="transparent"
                                style="border-radius:8px!important"
                                :to="item.link"
                            >
                                <v-layout
                                    v-bind="{
                                        'align-center': true,
                                        'justify-center': true,
                                        column: detect == 'mobile',
                                        style: {
                                            gap: detect == 'pc' ? '8px' : '12px',
                                        },
                                    }"
                                >
                                    <v-icon :large="detect == 'mobile'">
                                        {{ item.icon }}
                                    </v-icon>
                                    <span class="font-weight-bold grey--text text--darken-2">
                                        {{ item.text }}
                                    </span>
                                </v-layout>
                            </v-btn>
                        </v-responsive>
                    </v-col>
                </template>
                <v-col cols="12" order="12" v-if="detect == 'mobile'">
                    <v-btn x-large block style="border-radius: 8px !important" to="/center/notifications">
                        <span>고객센터</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import detect from "@/plugins/detect";

export default {
    data: () => ({
        detect,
    }),
    computed: {
        items() {
            return [
                {
                    icon: "mdi-book-outline",
                    text: "도서 내역",
                    link: { path: "/mypage/shop/purchases" },
                    props_col: {
                        order: detect == "pc" ? 1 : 3,
                    },
                },
                {
                    icon: "mdi-gift-outline",
                    text: "쿠폰 내역",
                    link: { path: "/mypage/gshop/orders" },
                    props_col: {
                        order: detect == "pc" ? 2 : 2,
                    },
                },
                {
                    icon: "mdi-truck-outline",
                    text: "배송상품 내역",
                    link: { path: "/mypage/dshop/orders" },
                    props_col: {
                        order: detect == "pc" ? 3 : 4,
                    },
                },
                {
                    icon: "mdi-credit-card-plus-outline",
                    text: "나누리 교환 내역",
                    link: { path: "/mypage/exchange" },
                    props_col: {
                        order: detect == "pc" ? 4 : 1,
                    },
                },
                {
                    icon: "mdi-message-question-outline",
                    text: "1:1 문의",
                    link: { path: "/center/questions" },
                    props_col: {
                        order: detect == "pc" ? 5 : 5,
                    },
                },
                {
                    icon: "mdi-account-circle-outline",
                    text: "회원정보 수정",
                    link: { path: "/mypage/profile" },
                    props_col: {
                        order: detect == "pc" ? 6 : 6,
                    },
                },
                {
                    icon: "mdi-plus-circle-multiple-outline",
                    text: "리워드 캐시내역",
                    link: { path: "/mypage/cashes/inquiry?type=rwd" },
                    props_col: {
                        order: detect == "pc" ? 7 : 7,
                    },
                },
            ];
        },
    },
};
</script>

<style></style>
